import axios from 'axios'

const api = 'http://localhost:3001'
const apiTesting = "http://10.53.25.122:5000"

export const getDoorprize = async (context, id) => {
  try {
    const {data} = await axios.get(`${process.env.VUE_APP_API2}/api/prizes`)
    // console.log(data, "<<data di action")
    context.commit('SET_DOORPRIZE_DATA', {data: data.data, type: id})
  } catch (error) { 
    console.log(error)
  }
}

export const getPersonDoorprize = async (context, id) => {
  try {
    const {data} = await axios.get(`${process.env.VUE_APP_API2}/api/availpeople`)
    // console.log(data.data, "<<data di actionnya dp")
    context.commit('GET_PERSON_DOORPRIZE', data.data)
    context.commit('fetchPerson', data.data)
    
  } catch (error) {
    
  }
}



export const updateDataDoorprize = async (context, payload) => {
  try {
    const responsePrize = await axios.post(`${process.env.VUE_APP_API2}/api/prizes/winners/${payload.prizeId}`, {userId: payload.winners})
    // const responseWinners = await axios.post(`${apiTesting}/api/prizes/winners/post`, {userId: payload.winners})
    console.log(payload, responsePrize, '< response prize doorprize payload')
    // console.log(responseWinners, '< responseWinners doorprize payload')     
  } catch (error) {
    console.log(payload, error, "< update data doorprize error")
  }
}

export const updatePersonDoorprize = async (context, payload) => {
  try {
    // payload.forEach( async item => {
    //   console.log(item, " < user id buat post", ">no get kado", +item.get_kado)
    //   const responseWinners = await axios.post(`${apiTesting}/api/prizes/winners/post`, {userId: payload.winners})
    //   // const responseWinners = await axios.post(`${apiTesting}/api/prizes/winners/${+item}`)
    //   console.log(responseWinners, "<< response")
    // })
    const responseWinners = await axios.post(`${process.env.VUE_APP_API2}/api/winners/post`, {userId: payload})
      // const responseWinners = await axios.post(`${apiTesting}/api/prizes/winners/${+item}`)
      console.log(responseWinners, "<< response")
    
  } catch (error) {
    console.log(error, payload)
  }
}